import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'RevieveModalLazy',
        path: () => path.join(__dirname, './RevieveModal'),
        resolve: () => require.resolveWeak('./RevieveModal'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "RevieveModalLazy" */ './RevieveModal')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
